import { render, staticRenderFns } from "./ProspectDetails.vue?vue&type=template&id=1cfee4c2&scoped=true&"
import script from "./ProspectDetails.vue?vue&type=script&lang=js&"
export * from "./ProspectDetails.vue?vue&type=script&lang=js&"
import style0 from "./ProspectDetails.vue?vue&type=style&index=0&id=1cfee4c2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cfee4c2",
  null
  
)

export default component.exports